module.exports = __webpack_public_path__ + "static/img/logo.dc3be0d4.png";